import { AlertCircle, Filter, List } from "lucide-react";
import { PlaylistItem } from "./PlaylistItem";
import { VideoFilter } from "./VideoFilter";

export const PlaylistSection = ({
    showPlaylist,
    setShowPlaylist,
    playlistLoading,
    playlistError,
    playlist,
    selectedVideoId,
    handlePlaylistItemSelect,
    getThumbnailColor,
    getFileUrl,
    allSystems,
    isLoading,
    onFiltersApplied
}) => {
    return (
        <div className="min-h-0">
            <div className="h-full overflow-hidden rounded-lg shadow-lg flex flex-col">
                {/* Header */}
                <div className="p-4 border-b flex items-center justify-between bg-gray-50">
                    <h3 className="font-semibold text-base text-gray-800">
                        {showPlaylist ? "Video Playlist" : "Filters"}
                    </h3>
                    <button
                        onClick={() => setShowPlaylist(!showPlaylist)}
                        className="p-2 hover:bg-gray-200 rounded-lg transition-colors"
                        title={showPlaylist ? "Show Filters" : "Show Playlist"}
                    >
                        {showPlaylist ? <Filter size={20} /> : <List size={20} />}
                    </button>
                </div>

                {/* Content */}
                <div className="overflow-y-auto flex-1">
                    {showPlaylist ? (
                        <PlaylistContent
                            playlistLoading={playlistLoading}
                            playlistError={playlistError}
                            playlist={playlist}
                            selectedVideoId={selectedVideoId}
                            handlePlaylistItemSelect={handlePlaylistItemSelect}
                            getThumbnailColor={getThumbnailColor}
                            getFileUrl={getFileUrl}
                        />
                    ) : (
                        <VideoFilter
                            systems={allSystems}
                            isLoading={isLoading}
                            onFiltersApplied={onFiltersApplied}
                            setShowPlaylist={setShowPlaylist}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

const PlaylistContent = ({
    playlistLoading,
    playlistError,
    playlist,
    selectedVideoId,
    handlePlaylistItemSelect,
    getThumbnailColor,
    getFileUrl
}) => {
    if (playlistLoading) {
        return (
            <div className="flex items-center justify-center h-full">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2"></div>
                    <p className="text-sm text-gray-600">Loading playlist...</p>
                </div>
            </div>
        );
    }

    if (playlistError) {
        return (
            <div className="flex items-center justify-center h-full p-4">
                <div className="text-center">
                    <AlertCircle className="w-8 h-8 text-red-500 mx-auto mb-2" />
                    <p className="text-sm text-red-600 mb-1">Failed to load playlist</p>
                    <p className="text-xs text-gray-500">{playlistError}</p>
                </div>
            </div>
        );
    }

    if (playlist.length === 0) {
        return (
            <div className="flex items-center justify-center h-full p-4">
                <div className="text-center">
                    <List className="w-8 h-8 text-gray-400 mx-auto mb-2" />
                    <p className="text-sm text-gray-600">No videos available</p>
                    <p className="text-xs text-gray-500 mt-1">Apply filters to load videos</p>
                </div>
            </div>
        );
    }

    return (
        <div className="divide-y">
            {playlist.map((video, index) => (
                <PlaylistItem
                    key={video.id}
                    video={video}
                    index={index}
                    isActive={selectedVideoId === video.id}
                    onSelect={handlePlaylistItemSelect}
                    getThumbnailColor={getThumbnailColor}
                    getFileUrl={getFileUrl}
                />
            ))}
        </div>
    );
};
